import {useQuery} from "@tanstack/react-query";
import {CrmSystemService} from "../services/crm_system.service";

export const useCrmSystems = (enabled = true) => {
    return useQuery({
        queryKey: ["keyCrmSystems"],
        queryFn: () => CrmSystemService.getCrmSystems(),
        refetchOnWindowFocus: false,
        staleTime: 60 * 60 * 1000,
        gcTime: 60 * 60 * 1000,
        enabled,
    });
};